<div class="-md:flex-col mt-5 flex items-stretch justify-center gap-5">
  <section
    class="rounded-4xl 2xl:px-18 flex flex-1 flex-col items-stretch justify-between bg-neutral-100 px-8 py-10 md:items-start md:px-10 lg:px-14"
    data-testid="page-residential-services-section"
  >
    <i
      class="g-filter-green-600 block h-12 w-12"
      [style.background-image]="'url(' + iconPath + '/trash-container.svg)'"
    ></i>

    <h4 class="mt-10 text-2xl font-bold text-blue-900">Residential Services</h4>
    <p class="text-gray-750 mt-4 grow text-base font-normal">
      We offer homeowners a range of services, including routine pick-ups facilitated by our innovative automated side
      loader trucks enhancing the efficiency of our pickups. Our custom waste solutions are made to fit any residential
      need. We also provide dumpster rentals for moving, remodeling, or general cleanup projects.
    </p>

    <a
      cslButton
      class="mt-8 px-7 py-4"
      [routerLink]="routerUrls.residential"
      gtmLinkClick="cta_click"
      data-testid="order-residential-service-button"
    >
      Order Residential Service
      <i class="g-filter-blue-900 block h-6 w-6" [style.background-image]="'url(' + iconPath + '/arrow_right.svg)'"></i>
    </a>
  </section>

  <section
    class="rounded-4xl 2xl:px-18 flex flex-1 flex-col items-stretch justify-between bg-neutral-100 px-8 py-10 md:items-start md:px-10 lg:px-14"
    data-testid="page-commercial-services-section"
  >
    <i class="g-filter-green-600 block h-12 w-12" [style.background-image]="'url(' + iconPath + '/trash-car.svg)'"></i>

    <h4 class="mt-10 text-2xl font-bold text-blue-900">Commercial Services</h4>
    <p class="text-gray-750 mt-4 grow text-base font-normal">
      No matter what business you’re in, we are equipped to provide safe, dependable, and environmentally friendly waste
      and recycling services. We have a wide range of service schedules and containers to fit any customer need. Our
      industry professionals will help you choose the best service for your business requirements.
    </p>
    <a
      class="mt-8 px-7 py-4"
      cslButton
      [routerLink]="routerUrls.commercial"
      gtmLinkClick="cta_click"
      data-testid="order-commercial-service-button"
    >
      Request Commercial Service
      <i
        class="g-filter-blue-900 -mr-1.5 block h-6 w-6"
        [style.background-image]="'url(' + iconPath + '/arrow_right.svg)'"
      ></i>
    </a>
  </section>
</div>

<div
  class="rounded-4xl mt-5 flex flex-col-reverse items-stretch justify-center gap-5 bg-neutral-100 lg:flex-row"
  data-testid="page-dumpster-rental-section"
>
  <div
    class="2xl:px-18 min-h-72 basis-1/2 bg-[url(../assets/images/dumpster_bg.png)] bg-contain bg-[left_center] bg-no-repeat px-8 md:min-h-96 md:px-10 lg:px-14 lg:py-10"
  ></div>
  <section
    class="2xl:px-18 flex basis-1/2 flex-col items-stretch justify-between px-8 pt-10 md:items-start md:pb-0 lg:px-14 lg:pb-10"
  >
    <i
      class="g-filter-green-600 block h-12 w-12"
      [style.background-image]="'url(' + iconPath + '/container-icon.svg)'"
    ></i>

    <h4 class="mt-10 text-2xl font-bold text-blue-900">Dumpster Rental Services</h4>
    <p class="text-gray-750 mt-4 grow text-base font-normal">
      Casella offers dumpster rental services that are perfect for construction and remodelling; house, basement and
      attic clean-outs; special events; and any other short-term project. We have a wide range of sizes available to fit
      any job.
    </p>
    <a
      class="mt-8 px-7 py-4"
      cslButton
      [routerLink]="routerUrls.rollOff"
      gtmLinkClick="cta_click"
      data-testid="order-dumpster-rental-button"
    >
      Request Dumpster Rental
      <i
        class="g-filter-blue-900 -mr-1.5 block h-6 w-6"
        [style.background-image]="'url(' + iconPath + '/arrow_right.svg)'"
      ></i>
    </a>
  </section>
</div>

<div
  class="2xl:px-18 mx-auto mt-14 flex flex-col justify-between gap-6 px-4 pb-16 pt-14 md:flex-row md:items-end md:px-10 lg:px-14 xl:w-10/12"
  data-testid="page-contact-us-section"
>
  <section class="md:w-2/3">
    <h4
      class="self-stretch text-[44px] font-black uppercase leading-[50px] tracking-wide text-white md:text-4xl lg:text-5xl xl:text-[90px] xl:leading-[100px]"
    >
      Looking for <br />
      <span class="md:text-nowrap">
        <span class="green-stroke text-transparent">CUSTOMIZED</span>
        Service
      </span>
      Offerings?
    </h4>
    <p class="mt-6 text-base font-normal text-white md:mt-16 lg:mt-11 lg:w-2/3 xl:mt-16">
      Our industry professionals will help you choose the best service for your personal or business requirements.
    </p>
  </section>

  <a
    href="{{ contactUsUrl }}"
    target="_blank"
    gtmLinkClick="cta_click"
    cslButton="secondary-link"
    [inverted]="true"
    size="lg"
    class="h-[136px] w-[136px] flex-col !bg-green-500 !px-0"
    data-testid="home-page-contact-us"
  >
    <i
      class="g-filter-blue-900 block h-6 w-6 -rotate-45"
      [style.background-image]="'url(' + iconPath + '/arrow_right.svg)'"
    ></i>
    Contact Us
  </a>
</div>
